// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-card {
  display: flex;
}

.text {
  display: flex;
  font-size: 0.8rem;
  justify-content: space-between;
  width: 100%;
}

.message-container {
  width: 85%;
}

.chat-container {
  height: 90vh;
}

.selected {
  background: #EBEBEB;
}

.img-container {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chat-history {
  height: 90%;
  overflow: auto;
}

.chat-input {
  width: 100%;
  border-top: 1px solid lightgray;
}
.chat-input form {
  display: flex;
  width: 100%;
}
.chat-input input {
  width: 80%;
  border: none;
}
.chat-input button {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: none;
}

.chat-message {
  display: flex;
  flex-flow: column;
}

.doctor-message {
  width: 80%;
  background: #E5E5EA;
  border-radius: 20px;
  padding: 5px 20px;
  color: #111;
  align-self: flex-end;
}

.user-message {
  width: 80%;
  background: #29B6F6;
  border-radius: 20px;
  padding: 5px 20px;
  color: white;
  margin-left: 1rem;
}

.max-he {
  max-height: 600px;
}

.over-h {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/chat.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,aAAA;EACA,iBAAA;EACA,8BAAA;EACA,WAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,+BAAA;AACJ;AACI;EACI,aAAA;EACA,WAAA;AACR;AAEI;EACI,UAAA;EACA,YAAA;AAAR;AAGI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AADR;;AAKA;EACI,aAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;AAFJ;;AAKA;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ","sourcesContent":[".chat-card{\r\n    display: flex;\r\n}\r\n\r\n.text{\r\n    display: flex;\r\n    font-size: 0.8rem;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n\r\n.message-container{\r\n    width: 85%;\r\n}\r\n\r\n.chat-container{\r\n    height: 90vh;\r\n}\r\n\r\n.selected{\r\n    background: #EBEBEB;\r\n}\r\n\r\n.img-container{\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    overflow: hidden;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.chat-history{\r\n    height: 90%;\r\n    overflow: auto;\r\n}\r\n\r\n.chat-input{\r\n    width: 100%;\r\n    border-top: 1px solid lightgray;\r\n\r\n    form{\r\n        display: flex;\r\n        width: 100%;\r\n    }\r\n\r\n    input{\r\n        width: 80%;\r\n        border: none;\r\n    }\r\n\r\n    button{\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        border:none;\r\n        background: none;\r\n    }\r\n}\r\n\r\n.chat-message{\r\n    display: flex;\r\n    flex-flow: column;\r\n}\r\n\r\n.doctor-message{\r\n    width: 80%;\r\n    background: #E5E5EA;\r\n    border-radius: 20px;\r\n    padding: 5px 20px;\r\n    color: #111;\r\n    align-self: flex-end;\r\n}\r\n\r\n.user-message{\r\n    width: 80%;\r\n    background: #29B6F6;\r\n    border-radius: 20px;\r\n    padding: 5px 20px;\r\n    color: white;\r\n    margin-left: 1rem;\r\n}\r\n\r\n.max-he{\r\n    max-height: 600px;\r\n}\r\n\r\n.over-h{\r\n    overflow: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
